import { render, staticRenderFns } from "./approval-node.vue?vue&type=template&id=43c12caa&"
import script from "./approval-node.vue?vue&type=script&lang=js&"
export * from "./approval-node.vue?vue&type=script&lang=js&"
import style0 from "./approval-node.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports